/* assets/giddy-reveal.js
   Site-wide scroll-reveal observer. Watches all .reveal-* classes and toggles
   .is-visible on viewport entry. Elements that leave the viewport going BELOW
   us (scroll-up) are un-revealed so they re-animate on scroll-down. Elements
   that leave going ABOVE us (we scrolled down past them) stay visible.
   CSS animation rules live in assets/section-giddy-homepage.css. */
(function () {
  'use strict';

  function init() {
    var revealEls = document.querySelectorAll(
      '.reveal-on-scroll, .reveal, .reveal-up, .reveal-fade, ' +
      '.reveal-scale, .reveal-pop, .reveal-left, .reveal-right'
    );
    if (!revealEls.length) return;

    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
          } else if (e.boundingClientRect.top > 0) {
            // Element left the viewport going DOWN (below us) → user scrolled up.
            // Hide it so it re-animates on the next scroll-down pass.
            e.target.classList.remove('is-visible');
          }
          // If element left going UP (above us, top < 0), keep is-visible
          // so sections behind us don't blink out.
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
